import React, { FC, useEffect, useState } from 'react';

import { OptionType } from '@evinced-private/ui-common';

import { IPropertyView, IPropertyViewRow } from '../../interfaces/PropertyViews';
import { IPropertyViewContext, usePropertyViewContext } from '../../providers/PropertyViewProvider';
import { SiteScannerTable } from '../common/site-scanner-table/SiteScannerTable';

import { getFilterViews, getViewsTableColumns } from './ManageViewsTableHelper';

import './ManageViewsTable.scss';

interface IManageViewsTableProps {
	searchFilter: string;
	issueTypesList: OptionType[];
	issueSeveritiesList: OptionType[];
}

const ManageViewsTable: FC<IManageViewsTableProps> = ({
	searchFilter,
	issueTypesList,
	issueSeveritiesList
}) => {
	const [isLoading, setLoading] = useState<boolean>(true);
	const [allViews, setAllViews] = useState<IPropertyViewRow[]>(null);
	const [tableData, setTableData] = useState<IPropertyViewRow[]>([]);
	const propertyViewContext: IPropertyViewContext = usePropertyViewContext();

	useEffect(() => {
		if (!allViews) {
			return;
		}
		const filteredViews = getFilterViews(allViews, searchFilter);
		setTableData(filteredViews);
	}, [searchFilter, allViews]);

	useEffect(() => {
		const propertyViewsList: IPropertyView[] = propertyViewContext.propertyViews;
		const data: IPropertyViewRow[] = propertyViewsList.map((propertyView) => ({
			...propertyView,
			searchStr: `${propertyView.name}`.toLowerCase()
		}));

		setAllViews(data);
		setLoading(false);
	}, [propertyViewContext.propertyViews]);

	return (
		<SiteScannerTable
			tableId="manage-views-table"
			tableData={tableData}
			totalCount={tableData.length}
			className="manage-views-table"
			columns={getViewsTableColumns(issueTypesList, issueSeveritiesList)}
			options={{
				title: 'Manage Views',
				pagination: true,
				dataType: 'views',
				caption: 'Manage views table'
			}}
			isTableLoading={isLoading}
			persistTableState
		/>
	);
};

export { ManageViewsTable };
